import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import './EtchStoryWithImage.scss';

const EtchStoryWithImage = (props) => {
  const { opts = {} } = props;
  const {
    description,
    id,
    images = [{}],
    cta,
    ctaLink,
    title,
    type
  } = opts;
  return (
    <div className="EtchStoryWithImage etch-analytics" id={id} data-module-id={id} data-module-type={type}>
      <div className="storyInfo">
        <h3 className="storyInfo__title">{title}</h3>
        <p className="storyInfo__description">{description}</p>
        {cta
        && (
          <a className="storyInfo__btn bttn bttn--primary bttn--inline" href={ctaLink}>
            <span className="story__btn__content bttn__content">{cta}</span>
          </a>
        )}
      </div>
      <div className="storyImage">
        {images
          && images.map((imageList) => {
            const { image = {} } = imageList;
            const { src, alt, height, width } = image;
            const imgClass = classNames({
              'img--block':height && width
            });

            return (
              <div className="storyImage__img">
                <Image
                  stretchy
                  className={imgClass}
                  src={src}
                  alt={alt}
                  height={height}
                  width={width}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

EtchStoryWithImage.propTypes = {
  opts: PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.string,
    images: PropTypes.array,
    cta: PropTypes.string,
    ctaLink: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
  }).isRequired
};
EtchStoryWithImage.defaultProps = {
};

export default EtchStoryWithImage;
